import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../services/db";

const RecipeCard = ({
  recipe: { name, author, tags, imgSrc, id, imgInDatabase },
  boardId,
}) => {
  const [image, setImage] = useState();

  const getImage = async (imgSrc, imgInDatabase) => {
    if (imgSrc) {
      try {
        if (imgInDatabase) {
          const { data, error } = await supabase()
            .storage.from("recipe-images")
            .createSignedUrl(imgSrc, 3600);
          if (error) {
            throw new Error("Not found");
          }
          setImage(data?.signedUrl);
        } else {
          setImage(imgSrc);
        }
      } catch (e) {
        setImage(imgSrc);
      }
    }
  };

  useEffect(() => {
    getImage(imgSrc, imgInDatabase);
  }, [imgSrc, imgInDatabase]);

  return (
    <Link
      key={id}
      to={boardId ? `/${boardId}/recipe/${id}` : `/recipe/${id}`}
      className="noTextDecoration"
    >
      <div className="flexColumn blackFont">
        <img
          style={{ width: "250px", height: "250px" }}
          src={image}
          alt=""
          onLoad={() => {
            URL.revokeObjectURL(image);
          }}
        />
        <p>{name} </p>
        <p>{author && `Author: ${author}`}</p>
        <div>
          {tags?.map((tag) => (
            <div key={tag}> Tag: {tag}</div>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default RecipeCard;
